import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { RefreshCw, CheckCircle } from 'lucide-react';
import BirdMascot from '../components/BirdMascot';

const ResetPage = () => {
  const navigate = useNavigate();
  const [isReset, setIsReset] = React.useState(false);

  useEffect(() => {
    // Clear all JailBirds data
    localStorage.removeItem('jailbirds_nickname');
    localStorage.removeItem('jailbirds_player_id');
    localStorage.removeItem('jailbirds_avatar_id');
    setIsReset(true);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Card className="p-8 max-w-md text-center bg-gradient-card border-border shadow-2xl">
          <div className="flex justify-center gap-3 mb-6">
            <BirdMascot size={60} color="#10B981" />
            <BirdMascot size={60} color="#FF6B6B" />
            <BirdMascot size={60} color="#8B5CF6" />
          </div>

          {isReset ? (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h1 className="text-3xl font-heading font-bold mb-3 text-gradient-primary">
                All Clear!
              </h1>
              <p className="text-muted-foreground mb-6">
                Your nickname and avatar have been reset. You can now create a new profile!
              </p>
            </>
          ) : (
            <>
              <RefreshCw className="w-16 h-16 text-primary mx-auto mb-4 animate-spin" />
              <h1 className="text-3xl font-heading font-bold mb-3">
                Resetting...
              </h1>
            </>
          )}

          <Button
            size="lg"
            onClick={() => navigate('/')}
            className="w-full bg-gradient-primary hover-glow-primary text-primary-foreground font-semibold"
          >
            Create New Profile
          </Button>
        </Card>
      </motion.div>
    </div>
  );
};

export default ResetPage;
